import { CharacterNameValues, CharacterVillainValues } from '../../vehicle/Character';
import { ChargeStripSkinsValues } from '../entities/ChargeStrip';
import { RampSkinsValues } from '../entities/Ramp';
import { ThemeNameValues } from '../themes/theme';
import { VehicleHandling } from './../../vehicle/Vehicle';

export const LevelName = {
  Level1: 'level1',
  Level2: 'level2',
  Level3: 'level3',
  Level4: 'level4',
  Level5: 'level5'
} as const;
export type LevelNameKeys = keyof typeof LevelName;
export type LevelNameValues = typeof LevelName[LevelNameKeys];

export const LevelState = {
  Purchased: 'Purchased',
  Unlocked: 'Unlocked',
  Locked: 'Locked'
} as const;
export type LevelStateKeys = keyof typeof LevelState;
export type LevelStateValues = typeof LevelState[LevelStateKeys];

export const LevelStage = {
  LootDropSection: 'lootDropSection',
  RampSection: 'rampSection',
  ChargeUpSection: 'chargeUpSection'
};
export type LevelStageKeys = keyof typeof LevelStage;
export type LevelStageValues = typeof LevelStage[LevelStageKeys];

export interface Level {
  id: LevelNameValues;
  theme: ThemeNameValues;
  scoring: Scoring;
  hero: CharacterNameValues;
  heroVehicleHandling: VehicleHandling;
  villain: CharacterVillainValues;
  villainVehicleHandling: VehicleHandling;
  stages: StageData[];
}

export interface Scoring {
  starRatings: number[];
}

export interface StationDetails {
  distance: number;
}

// export interface VillainDetails {}

export interface Stage {
  stageType: LevelStageValues;
}

export type StageData = LootStage | RampStage | ChargeStage;

export interface LootStage extends Stage {
  dropQuantity: number;
  dropRateMin: number;
  dropRateMax: number;
  specialDropInterval: number;

  // Weapon.
  shouldVillainUseTrapWhileDropping?: boolean;
  shouldTriggerOnDrops: boolean;
  weaponTriggerPoints: number[];
}

export interface RampStage extends Stage {
  rampSkin: RampSkinsValues;
  rampsToJump: number;
}

export interface ChargeStage extends Stage {
  skin?: ChargeStripSkinsValues;
  chargeAmount?: number; // Used for easy testing.
}
